import { immer } from "zustand/middleware/immer";

interface MspFlagProps {
  name: string;
  enabled: boolean;
}
interface MspFlagsState {
  mspFlags: Record<string, any>;
}

interface MspFlagsAction {
  setMspFlags: (flags: Array<MspFlagProps>) => void;
}

export interface MspFlagsInterface extends MspFlagsState, MspFlagsAction {}

export const mspFlagsSlice = immer<MspFlagsInterface>((set) => ({
  mspFlags: {},
  setMspFlags: (flags) => {
    set((state) => {
      const mspFlagObject = {};
      flags.map((item: MspFlagProps) => {
        // @ts-ignore
        mspFlagObject[`${item.feature_flag_name}`] = item.enabled;
      });
      state.mspFlags = mspFlagObject;
    });
  },
}));
